const MPA_ORGANIZATION_SLUG = 'medpower';

export default MPA_ORGANIZATION_SLUG;
